import api from '../utils/axios';

export async function getReconsiderationDraft(ticketId) {
  const { data } = await api.get(`/claims/action-tickets/${ticketId}/`);
  return data;
}

export async function getClaimActionEligibility(claimId) {
  const { data } = await api.get(`/claims/${claimId}/claim-actions/eligibility/`);
  return data;
}

// Queue a read-only Optum reconcile that makes a NOT_CREATABLE-failed ticket
// update-ready (recovers ticket_number + allowedAction='Update'). Never submits.
export async function reconcileClaimAction(claimId) {
  const { data } = await api.post(`/claims/${claimId}/claim-actions/reconcile/`);
  return data;
}

// Queue a read-only Optum status refresh (status / outcome / allowedAction / isClosed).
export async function refreshReconsiderationStatus(ticketId) {
  const { data } = await api.post(`/claims/action-tickets/${ticketId}/refresh/`);
  return data;
}

// Submit an Optum ticketAction="Update" against an existing ticket: new reason,
// provider comment, and additional documents (uploaded via ticketNumber).
export async function submitTicketUpdate(ticketId, payload) {
  const { data } = await api.post(`/claims/action-tickets/${ticketId}/update-submit/`, payload);
  return data;
}
